export enum AsyncActionMethods {
	Error = 'error',
	Failed = 'failed',
	Receive = 'receive',
	Repeat = 'repeat',
	Request = 'request',
	Reset = 'reset'
}
